import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Grid from '@material-ui/core/Grid';
import React from 'react';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import UserSelection from '../../../Organisms/UserSelection';
export interface IChannelsUserDetailsProps {
    privateMode: boolean;
    setPrivateMode: Function;
    userSelectionHook: any;
    madeWhitelist?: any;
}

const ChannelsUserDetails = ({ privateMode, setPrivateMode, userSelectionHook }: IChannelsUserDetailsProps) => {
    interface IWhitelist {
        [key: string]: any;
    }

    const handlePublicToggle = () => {
        if (privateMode === true) {
            // customUserSelectHook.clearAll();
        }
        setPrivateMode(!privateMode);
    };

    const Toggle = ({ handleToggle, privateMode }: any) => {
        return (
            <FormControl component="fieldset" style={{ padding: '10px' }}>
                <FormLabel component="legend">Is this a private channel?</FormLabel>
                <FormGroup>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={privateMode}
                                name="Channel-private-toggle"
                                onChange={handleToggle}
                                value={privateMode}
                            />
                        }
                        label={`${privateMode ? 'Yes' : 'No'}`}
                        style={{ justifyContent: 'center' }}
                    />
                </FormGroup>
            </FormControl>
        );
    };
    //We want to pass in the currently-whitelisted users to our UserSelection component so that it is correctly pre-selected
    return (
        <React.Fragment>
            <Grid container spacing={5}>
                <Grid container direction="column" justify="center">
                    <Toggle handleToggle={handlePublicToggle} privateMode={privateMode} />
                    {!privateMode && (
                        <Typography component="h3" gutterBottom style={{ padding: '10px' }} variant="body1">
                            All active event users will have access to the channel
                        </Typography>
                    )}
                </Grid>

                {privateMode && (
                    <UserSelection
                        initiallySelected={[]}
                        label="channels-create"
                        userSelectionHook={userSelectionHook}
                    />
                )}
            </Grid>
        </React.Fragment>
    );
};

export default ChannelsUserDetails;
